import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, LL_H_C, LL_V_L, ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
import './Base_RequestTemplate.scss';
import { ICONS } from '@app/styles';
import { sortArray } from '@nu-art/ts-common';
export const dispatch_SelectTemplate = new ThunderDispatcher('__onTemplateSelected');
export class Base_RequestTemplate extends ComponentSync {
    deriveStateFromProps(props, state) {
        (async () => {
            try {
                const templates = await this.getTemplates();
                this.setState({ templates });
            }
            catch (e) {
                this.logError('Failed to load templates', e);
            }
        })();
        state.templates ??= [];
        return state;
    }
    selectTemplate(template, index) {
        this.setState({ selected: template, selectedIndex: index }, () => dispatch_SelectTemplate.dispatchUI(template));
    }
    render() {
        return _jsxs(LL_V_L, { className: 'order-request-templates', children: [_jsx("div", { className: 'order-request-templates__header', onClick: () => this.reDeriveState(), children: "Templates" }), _jsx(LL_V_L, { className: 'templates-container', children: sortArray(this.state.templates, ((template) => template.label?.trim())).map(((template, i) => {
                        const className = _className('predefined-option', i === this.state.selectedIndex && 'selected');
                        return _jsxs(LL_H_C, { className: className, onClick: () => {
                                this.selectTemplate(template, i);
                            }, children: [this.renderTemplate(template), _jsx(ICONS.send.component, {})] }, i);
                    })) })] });
    }
}
//# sourceMappingURL=Base_RequestTemplate.js.map